<template>
    <icon-button v-if="colorMode === 'light'" @click="changeColorMode('dark')">
        <icon-base size="20" name="sun" title="Activate dark mode" />
    </icon-button>
    <icon-button v-else @click="changeColorMode('light')">
        <icon-base size="20" name="moon" title="Activate light mode" />
    </icon-button>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import IconBase from '@/common/components/ui/icons/IconBase.vue'
import IconButton from '@/common/components/ui/icons/IconButton.vue'

export default defineComponent({
    name: 'ColorModeSwitcher',
    components: {
        IconBase,
        IconButton,
    },
    setup() {
        const store = useStore()

        const colorMode = computed(() => store.getters['ui/colorMode'])

        const changeColorMode = (mode: string) =>
            store.dispatch('ui/setColorMode', mode)

        return {
            changeColorMode,
            colorMode,
        }
    },
})
</script>
